<template>
  <el-row>
    <el-col :xs="24" :sm="6" :md="5" :lg="12" :xl="10">
      <el-card v-loading="isLoading">
        <div slot="header" class="clearfix">
          <span class="cadastro-title">Usuário -  {{ isEditing ? 'Editar' : 'Visualizar'}}</span>
        </div>
        <el-form label-position="left" label-width="100px" :model="userForm" ref="userForm" v-if="userForm">
          <el-form-item label="Nome" prop="name" :error="errors.name">
            <el-input v-model="userForm.name" :readonly="! isEditing"/>
          </el-form-item>
          <el-form-item label="Email" prop="email" :error="errors.email">
            <el-input v-model="userForm.email" :readonly="! isEditing"/>
          </el-form-item>
          <el-form-item label="Grupos" v-show="!isEditing">
            <el-tag v-for="role in userForm.roles" :key="role">{{role}}</el-tag>
          </el-form-item>
          <el-form-item label="Grupos" prop="roles" error="errors.roles" v-show="isEditing">
            <el-checkbox-group size="mini" v-model="userForm.roles" >
              <el-checkbox-button label="Administrator" >Administrador</el-checkbox-button>
              <el-checkbox-button label="Seeder">Seeder</el-checkbox-button>
              <el-checkbox-button label="Normal">Normal</el-checkbox-button>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item align="right">
            <el-button type="warning" @click="toList()">Lista</el-button>
            <el-button type="danger" v-show="! isEditing" @click="isEditing = true">Editar</el-button>
            <el-button type="primary" @click="onSubmit" v-show="isEditing">Salvar</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>

  import {error_form_transform} from "../../domain/utils";
  import {mapState, mapActions, mapGetters} from 'vuex'

  export default {
    name: "user-show",
    data() {
      return {
        isLoading: false,
        isEditing: false,
        errors: {
          name: null,
          email: null,
          role: null
        },
        userForm: null,
        teste: null
      }
    },
    computed: {
      ...mapState('User', ['userSelecte', 'list']),
      ...mapGetters('User', ['userSelectedRole', 'listById', 'findById'])
    },
    methods: {
      ...mapActions('User', ['setSelected', 'update' , 'setList']),
      ajusteRoles(roles) {
        return _.map(roles, 'name')
      },
      async onSubmit() {
        try {
          this.isLoading = true
          await this.update(this.userForm)
          this.$notify.success("Registro Atualizado com sucesso!")
        }
        catch (error) {
          if (_.isObjectLike(error.response)) {
            this.errors = error_form_transform(error.response.data.errors)
          }
          console.log(error)
        }
        finally {
          this.isLoading = false
        }
      },
      toList() {
        this.$router.push({name: 'user.index'})
      }
    },
    async mounted() {
      const userId = this.$route.params.user
      this.isLoading = true

      try {

        if (this.list.length === 0) {
          await this.setList()
        }

        this.userForm = this.findById(userId)
        this.userForm.roles =  this.ajusteRoles(this.userForm.roles)

      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/features/User/Show.vue